/* src/app/modules/expense-reports/components/report-review/list-concepts/list-concepts.component.scss */
/*# sourceMappingURL=list-concepts.component.css.map */
